var $ = require('jQuery');
var template = require('../../template/chat-window-header.html');
var Component = require('./../Component');
var ChatwindowHeader = function (options) {
    (function (self) {
        var defaults = {
            template: template,
            plugins: []
        };
        $.extend(defaults, options);
        Component.call(self, defaults);
        self._beforeTexts = [];
        $(defaults.plugins).each(function (index, plugin) {
            self._element.find('.im-cwheader-plugins').append(plugin.getElement());
            plugin.setCwHeader(self);
        });
    })(this);
};
ChatwindowHeader.prototype = Object.create(Component.prototype);
ChatwindowHeader.prototype.addBlackList = function () {
    this.triggerEvent('addBlackList');
};
ChatwindowHeader.prototype.delBlackList = function () {
    this.triggerEvent('delBlackList');
};
ChatwindowHeader.prototype.complaints = function () {
    this.triggerEvent('complaints');
};
ChatwindowHeader.prototype.isBlackedCheck = function () {
    this.triggerEvent('isBlackedCheck');
};
ChatwindowHeader.prototype.updateHandleText = function (text) {
    var liLists = this._element.find('.im-feedback-texts').find('LI');
    $(liLists).each(function (index, item) {
        var oldText = $(item).find('.im-feedback-text').text();
        if ((oldText.length > text.length && oldText.indexOf(text) !== -1) || (oldText.length < text.length && text.indexOf(oldText) !== -1)) {
            $(item).find('.im-feedback-text').text(text);
        }
    })
};
ChatwindowHeader.prototype.updateFeedBackList = function (texts, iconMap) {
    var self = this;
    if (self._beforeTexts && texts && JSON.stringify(self._beforeTexts) == JSON.stringify(texts)) {
        return;
    }
    self._element.find('.im-feedback-texts').html('');
    $(texts).each(function (index, item) {
        if (iconMap) {
            self._element.find('.im-feedback-texts').append($('<li class="texts-icon texts-icon-' + (iconMap[index] || index) + '"><span class="texts-icon texts-icon-' + (iconMap[index] || index) + '"></span><span class="im-feedback-text">' + item + '</span></li>'));
        } else {
            self._element.find('.im-feedback-texts').append($('<li class="texts-icon texts-icon-' + index + '"><span class="texts-icon texts-icon-' + index + '"></span><span class="im-feedback-text">' + item + '</span></li>'));
        }
    });
    self._beforeTexts = texts;
    if (texts && texts.length) {
        self._element.find('.im-feedback').removeClass('im-closed').show();
    } else {
        self._element.find('.im-feedback').hide();
    }
};
ChatwindowHeader.prototype.quitGroup = function () {
    this.triggerEvent('quitGroup');
};
ChatwindowHeader.prototype.disbandGroup = function () {
    this.triggerEvent('disbandGroup');
};
ChatwindowHeader.prototype.getGroupQrCode = function () {
    this.triggerEvent('getGroupQrCode');
};
ChatwindowHeader.prototype.groupNotice = function () {
    this.triggerEvent('groupNotice');
};
ChatwindowHeader.prototype.sesTop = function (boolean) {
    this.triggerEvent('sesTop', boolean);
};
ChatwindowHeader.prototype.setSilent = function (boolean) {
    this.triggerEvent('setSilent', boolean);
};
ChatwindowHeader.prototype.setGroup = function (boolean) {
    this.triggerEvent('setGroup', boolean);
};
ChatwindowHeader.prototype.switchFeedbackIcon = function (boolean) {
    if (boolean) {
        this._element.find('.im-feedback').show();
    } else {
        this._element.find('.im-feedback').hide();
    }
};
ChatwindowHeader.prototype.setUserRemark = function () {
  this.triggerEvent('setUserRemark');
};

module.exports = ChatwindowHeader;
